// generated from 8_642 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const ageFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("age_filter"),
  comparison_key: z.enum([
    "3", // 6_126 (70.89%)
    "5", // 2_516 (29.11%)
    // EQUALS is in AgeFilter#allowed_comparisons
    "1",
  ]),
  display_name: z.string(),
  // undefined: 5_075 (58.72%), defined 3_567 (41.28%)
  // avg: 296.04, min: 0, max: 900000
  raw_value: z.int().min(0).optional(),
  // avg: 138.53, min: 0, max: 900000
  value: z.int().min(0),
  varies_by_app_group: z.literal(false),
});
